<template>
    <div class="index">
        <div class="index-item">
            <!-- <div class="activity-center">
                <p>活动中心</p>
                <span>快来抢先体验</span>
            </div> -->
            <div class="bottom-wrapper">
                <div class="item-wrapper style-yellow" @click="toSign">
                    <div class="content-left">
                        <p>每日签到领金币</p>
                        <span>随机领取10-100金币</span>
                    </div>
                    <div class="right-btn">去试试</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Config from '@/config/config'
export default {
    name: 'AddressEdit',
    data() {
        return {}
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    methods: {
        /**
         * 去签到
         */
        toSign() {
            if (this.userInfo.id) {
                const signUrl = Config.creditStoreBaseUrl + '/activity/sign/?name=' + this.userInfo.nickname + '&gender=' + this.userInfo.gender +
                    '&province=' + this.userInfo.province + '&city=' + this.userInfo.city + '&avatar=' + this.userInfo.avatar +
                    '&userCode=' + this.userInfo.openid + '&appId=' + Config.creditStoreAppId + '&header=true'
                window.location.href = signUrl
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.index {
    background: #F6F8FA;
    height: 233px;
    background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);

    &-item {
        position: relative;
        display: flex;
        flex-direction: column;


        .activity-center {
            margin: 15px 0 12px 15px;

            p {
                color: #4a4a4a;
                font-size: 14px;
                font-weight: 600;
                display: inline-block;
                margin-right: 10px;
            }

            span {
                color: #747474;
                font-size: 14px;
                font-weight: 400;
            }
        }

        .bottom-wrapper {
            padding: 0 12px;

            .item-wrapper {
                width: 345px;
                height: 90px;
                margin: 10px auto;
                border-radius: 10px;
                box-sizing: border-box;
                padding: 20px;
                background-image: linear-gradient(-32deg, #56c1e8 0%, #48cfe1 100%);

                .content-left {
                    width: 60%;
                    display: inline-block;

                    p {
                        color: #ffffff;
                        font-size: 14px;
                        font-weight: 600;
                        height: 25px;
                        line-height: 25px;
                    }

                    span {
                        opacity: 0.8;
                        color: #ffffff;
                        font-size: 12px;
                        font-weight: 400;
                        height: 25px;
                    }
                }

                .right-btn {
                    width: 69px;
                    height: 22px;
                    margin: 14px 0;
                    display: inline-block;
                    border-radius: 11px;
                    background-color: #ffffff;
                    color: #FD8549;
                    font-size: 10px;
                    font-weight: 600;
                    line-height: 22px;
                    text-align: center;
                    float: right;
                }
            }

            .style-yellow {
                background-image: linear-gradient(31deg, #FE8045 0%, #F7B16C 100%);

                div {
                    color: #FD8549;
                }
            }
        }



    }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/index.vue